import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	emptyStatePlaceholderTitle: {
		id: 'company-hub.cards-extension.smart-card.empty-state.placeholder-title',
		defaultMessage: 'Add a title',
		description: 'Placeholder title that is displayed in Smart Card when no title is provided',
	},
});
